// CASE ASSIGNMENT SERVICE — Phase L
import { get, post, del } from '../client/axiosClient';
import { caseAssignmentEndpoints } from '../endpoints/caseAssignment.endpoints';
import type { ApiResponse, EmptyResponse, ID } from '../types';
import type {
  CaseAssignment,
  CaseRole,
  CreateCaseAssignmentRequest,
} from '../types/caseAssignment.types';

class CaseAssignmentService {
  async getRoles(): Promise<CaseRole[]> {
    const res = await get<ApiResponse<CaseRole[]>>(caseAssignmentEndpoints.roles());
    return res.data?.data ?? [];
  }

  async getByCase(caseId: ID, openOnly = false): Promise<CaseAssignment[]> {
    const res = await get<ApiResponse<CaseAssignment[]>>(caseAssignmentEndpoints.byCase(caseId, openOnly));
    return res.data?.data ?? [];
  }

  async create(req: CreateCaseAssignmentRequest): Promise<CaseAssignment> {
    const res = await post<ApiResponse<CaseAssignment>>(caseAssignmentEndpoints.create(), req);
    return res.data.data!;
  }

  async close(assignmentId: ID): Promise<EmptyResponse> {
    const res = await del<EmptyResponse>(caseAssignmentEndpoints.close(assignmentId));
    return res.data;
  }
}

export const caseAssignmentService = new CaseAssignmentService();
export default caseAssignmentService;
